export function adaptToDatabase(data, decimalFields) {
  let dataFormatted = { ...data }

  for (const [key, value] of Object.entries(data)) {
    if (decimalFields.includes(key)) {
      if (value !== null) {
        const removeSign = String(value).replace(/[R$]/gm, '').trim()

        let removeDot = removeSign
        if (/[,]/gm.test(value)) {
          removeDot = removeSign.replace(/[.]/gm, '').trim()
        }

        const valueFormatted = removeDot.replace(/[,]/gm, '.').trim()

        dataFormatted = {
          ...dataFormatted,
          [key]: Number(Number(valueFormatted).toFixed(2)),
        }
      } else {
        dataFormatted = {
          ...dataFormatted,
          [key]: value,
        }
      }
    }
  }

  return dataFormatted
}
